var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-button",class:{ disabled: _vm.disabled, hidden: _vm.hidden, caution: _vm.caution},on:{"click":_vm.onClick}},[_c('div',{staticClass:"my-button-title"},[_vm._v(_vm._s(_vm.title))]),_c('Loading')],1)}
var staticRenderFns = []

export { render, staticRenderFns }